export const PAGINATION_CLASSES = {
  pagination: `
      splide__pagination
    `.trim(),
  page: `
      splide__pagination__page
      appearance-none transition-colors rounded-full
      bg-transparent border-solid border-primary border box-border
      m-0 mx-1 p-0 w-2 h-2
    `.trim(),
};

export const CAROUSEL_INTERSECTION_SETTINGS = {
  intersection: {
    rootMargin: "200px",
    once: true,
  },
};

export const PAGE_CAROUSEL_OPTIONS = {
  autoWidth: true,
  cloneStatus: false,
  drag: true,
  flickMaxPages: 2,
  flickPower: 300,
  lazyLoad: true,
  gap: 0,
  mediaQuery: "min",
  pagination: false,
  speed: 600,
  trimSpace: "move",
  type: "slide",
  updateOnMove: true,

  breakpoints: {
    768: {
      gap: 0,
    },
    1280: {
      drag: false,
    },
  },

  classes: {
    ...PAGINATION_CLASSES,
  },
} as const;

export const TABBED_CAROUSEL_SETTINGS = {
  pagination: true,
  arrows: false,
  perPage: 1,
  cover: true,
  width: "100%",
  speed: 0,

  ...CAROUSEL_INTERSECTION_SETTINGS,
};

export const THUMBNAIL_CAROUSEL_MAIN_SETTINGS = {
  arrows: false,
  cover: true,
  drag: false,
  pagination: false,
  start: 2,
  type: "fade",
  width: "100vw",
} as const;

export const THUMBNAIL_CAROUSEL_NAV_SETTINGS = {
  arrows: false,
  cover: true,
  drag: true,
  flickMaxPages: 2,
  flickPower: 300,
  lazyLoad: true,
  gap: 0,
  isNavigation: true,
  mediaQuery: "min",
  pagination: true,
  perPage: 1,
  rewind: true,
  start: 2,
  type: "loop",
  updateOnMove: true,
  width: "100vw",

  breakpoints: {
    768: {
      drag: false,
      pagination: false,
      perPage: 5,
      type: "slide",
    },
  },

  classes: {
    ...PAGINATION_CLASSES,
  },
} as const;

export const PRODUCT_CARD_MAIN_SETTINGS = {
  drag: false,
  arrows: false,
  cover: true,
  gap: 0,
  lazyLoad: true,
  mediaQuery: "min",
  speed: 0,
  pagination: false,
  height: "auto",
} as const;

export const PRODUCT_CARD_NAV_SETTINGS = {
  arrows: false,
  drag: false,
  isNavigation: true,
  pagination: false,
  mediaQuery: "min",
} as const;

export const ANNOUNCEMENT_BAR_SETTINGS = {
  type: "fade",
  rewind: true,
  autoplay: true,
  interval: 3000,
  pagination: false,
  speed: 600,
} as const;

export const PRODUCT_GALLERY_SETTINGS = {
  arrows: false,
  classes: {
    ...PAGINATION_CLASSES,
  },
} as const;

export const SLIDE_FADE_CLASS = "opacity-30";
export const PAGINATION_ACTIVE_CLASS = "bg-primary";
export const PAGINATION_INACTIVE_CLASS = "bg-transparent";
